import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { ThreeDimensionSection as Original } from 'components/molecules'
import {
  ThreeDimensionSectionSettings,
  ThreeDimensionSectionFloatingSettings,
} from './ThreeDimensionSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'

export const defaultProps = {}

export const threeDimensionSectionItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  // name: getTextEditor(children?.[0], enabled),
  // description: getTextEditor(children?.[1], enabled),
})

export const dynamicProps = []

export const ThreeDimensionSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-three-dimension-section ${props.className}`}
      >
        <Original
          item={threeDimensionSectionItemParams(enabled, id, blockProps, children)}
          // editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

ThreeDimensionSection.craft = withCraft({
  name: 'ThreeDimensionSection',
  defaultProps: defaultProps,
  settings: ThreeDimensionSectionSettings,
  floatingSettings: ThreeDimensionSectionFloatingSettings,
})
